<template>
  <input
    type="text"
    class="basic-input"
    :value="value"
    :placeholder="placeholder"
    @input="$emit('input', $event.target.value)"
    @focus="$emit('focus')"
  />
</template>

<script>
export default {
  props: ["value", "placeholder"]
};
</script>

<style lang="scss">
$textColorLightGray: rgba(
  $color: #fff,
  $alpha: 0.85
);
$colorOrange: #fbb442;

.basic-input {
  max-width: 220px;
  //margin: 0 16px 0 0;
  color: $textColorLightGray;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  font-size: 12px;
  width: 100%;
  background: #303030;
  padding: 8px 10px;
  border: 1px solid #555555;
  border-radius: 2px;
  overflow: hidden;

  &.wide {
    max-width: 100%;
    min-width: 220px;
  }
  &.super-wide {
    min-width: 400px;
  }

  &.transparent {
    background-color: transparent;
    border: none;
    border-bottom: 1px solid #555555;
    padding: 8px 0;

    &:focus {
      border-bottom: 1px solid #fbb442;
    }
  }

  &:focus {
    color: #fff;
    border-color: $colorOrange;
  }
  &:hover {
    color: #fff;
  }
}
</style>